import React, { useState, useEffect } from 'react';
import LeaseApiService from '../../services/apiService';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PersonalDetails from './personalDetails';
import ContactDetails from './contactDetails';
import DocumentDetails from './documentDetails';
import Activity from './activity';
import GLAccount from './GLAccounts';
import PreferenceDetails from './preference';
import { getCountryFromCurrency } from '../../../INVENTORY/Layouts/currencyHelpers';
import AddressDetails from './additionalAddress';
import { toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getCompany, getName } from '../../../Redux/selecters';
import DependentDetails from './dependentDetails';
import { endPoint } from '../../EndPoints/endPoint';

const CustomerMaster = () => {
  const apiService = new LeaseApiService();
  let navigate = useNavigate();
  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const currencyList = JSON.parse(localStorage.getItem('currencylist')) || [];
  const defaultCountry = currencyPrecision?.code ? getCountryFromCurrency(currencyPrecision?.code, currencyList) : 'bh'; // fallback until API loads
  const [activeFY, setActiveFY] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false, false, false, false, false, false]);
  const [loading, setloader] = useState(false);
  const [contactList, setContactList] = useState([]);
  const [addressList, setAddressList] = useState([]);
  const [documentsList, setDocumentsList] = useState([]);
  const [activityList, setActivityList] = useState([]);
  const [preferenceList, setPreferenceList] = useState([]);
  const [sourceList, setSourceList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [salesPersonList, setSalesPersonList] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [agentList, setAgentList] = useState([]);
  const [dependentList, setDependentList] = useState([]);
  const [packageName, setPackageName] = useState([]);
  const [propertylist, setPropertyList] = useState([]);
  const [titleList, setTitleList] = useState([]);
  const [leadType, setLeadType] = useState([]);
  const [personalTabLeadType, setPersonalTabLeadType] = useState([]);
  const [activityRating, setActivityRating] = useState([]);
  const [language, setLanguage] = useState([]);
  const [woContact, setWOContact] = useState([]);
  const [activityStatus, setActivityStatus] = useState([]);
  const [ativityLeadType, setActivityLeadType] = useState([]);
  const [categoryMix, setCategoryMix] = useState([]);
  const [taxList, setTaxList] = useState([]);
  const [acountCodes, setAccountCodes] = useState([]);
  const [addContactType, setAddContactType] = useState([]);
  const [addAddressType, setAddAddressType] = useState([]);
  const [documentType, setDocumentType] = useState([]);
  const [prefIntrest, setPrefIntrest] = useState([]);
  const [prefBuying, setPrefBuying] = useState([]);
  const [locationMaster, setLocationMaster] = useState([]);
  const [UnitClass, setUnitClass] = useState([]);
  const [Properties, setProperties] = useState([]);
  const [UnitView, setUnitView] = useState([]);
  const [UnitTypeDesc, setUnitTypeDesc] = useState([]);
  const [UnitModel, setUnitModel] = useState([]);
  const [bedRooms, setBedRooms] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [countriesList, setCountries] = useState([]);
  const [nationalityList, setNationalitylist] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);

  const validationRules = [
    { key: 'type', message: 'Please Select Type from Personal Details' },
    { key: 'title', message: 'Please Select Title from Personal Details' },
    { key: 'firstName', message: 'Please Enter FullName' },
    { key: 'mobileNo', message: 'Please Enter Mobile No' },
    { key: 'email', message: 'Please Enter Email' },
    // { key: 'leadtype', message: 'Please Enter Lead Type' },
    { key: 'nationality', message: 'Please Enter Nationality' },
    // { key: 'source', message: 'Please Enter Source' },
    // { key: "subsource", message: "Please Enter Sub Source" },
    // { key: 'salesPerson', message: 'Please Enter Sales Person' },
    // { key: "dateofBirth", message: "Please Enter Date Of Birth" },
  ];
  const [gLAccounts, setGLAccounts] = useState({
    subgroup: null,
    accountcode: null,
    accountname: null,
    createledger: false,
    sgAccount: null,
    dateofBirth: null,
    vatNo: '',
    birthPlace: '',
    remarks: '',
    idNo: '',
    taxCode: null,
    issueDate: null,
    expiryDate: null,
    countryIssue: null,
    categoryMix: null,
  });
  const [transectionData, setTransectionData] = useState({
    salesPerson: '',
    type: '',
    mobileNo: '',
    agent: '',
    fullName: '',
    title: '',
    email: '',
    firstName: '',
    gender: '',
    lastName: '',
    phoneNo: '',
    poBox: '',
    categoryMix: '',
    salesPerson: '',
    address: '',
    dateofBirth: '',
    firstNameAR: '',
    lastNameAR: '',
    addressAR: '',
    source: '',
    designatoin: '',
    subsource: '',
    leadtype: '',
    countryCode: '',
    companyName: '',
    designation: '',
    nationality: null,
    productType: null,
  });
  useEffect(() => {
    fetchDropdownData();
    fetchDropdown();
    fetchDropData();
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    if (activeFinancialYear) {
      setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
    }
  }, []);
  const fetchDropdownData = async () => {
    try {
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'CustSource,SalesPersons,CustomerType,CustTitles,CustSource,CustAgents,LeadType,ActivityRating,CustPackageNames,PersonalTabLeadType',
      );
      const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
      setSourceList(res?.data?.dropdowns?.CustSource);
      setCustomerTypeList(res?.data?.dropdowns?.CustomerType);
      setSalesPersonList(res?.data?.dropdowns?.SalesPersons);
      setAgentList(res?.data?.dropdowns?.Agents);
      setPackageName(res?.data?.dropdowns?.CustPackageNames);
      setTitleList(res?.data?.dropdowns?.CustTitles);
      setLeadType(res?.data?.dropdowns?.LeadType);
      setPersonalTabLeadType(res?.data?.dropdowns?.PersonalTabLeadType);
      setActivityRating(res?.data?.dropdowns?.ActivityRating);
      setLeadStatus([
        { value: 'All', text: 'All' },
        { value: 'Open', text: 'Open' },
        { value: 'In Process', text: 'In Process' },
        { value: 'Closed', text: 'Closed' },
      ]);
      setTransectionData({
        ...transectionData,
        type: { label: 'Individual', value: res?.data?.dropdowns?.CustomerType[0] },
      });
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const fetchDropdown = async () => {
    try {
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'CategoryMix,TaxMaster,AccountCodes,AddContactType,AddAddressType,DocumentType,PrefIntrest,PrefBuying,LocationMaster,ActivityWayofContact,ActivityLanguage',
      );
      const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
      setCategoryMix(res?.data?.dropdowns?.CategoryMix);
      setTaxList(res?.data?.dropdowns?.TaxMaster);
      setAccountCodes(res?.data?.dropdowns?.AccountCodes);
      setAddContactType(res?.data?.dropdowns?.AddContactType);
      setAddAddressType(res?.data?.dropdowns?.AddAddressType);
      setDocumentType(res?.data?.dropdowns?.DocumentType);
      setPrefIntrest(res?.data?.dropdowns?.PrefIntrest);
      setPrefBuying(res?.data?.dropdowns?.PrefBuying);
      setLocationMaster(res?.data?.dropdowns?.LocationMaster);
      setLanguage(res?.data?.dropdowns?.ActivityLanguage);
      setWOContact(res?.data?.dropdowns?.ActivityWayofContact);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const fetchDropData = async () => {
    try {
      const params = new URLSearchParams();
      params.append(
        'dropdownTypes',
        'UnitClass,Properties,UnitView,UnitTypeDesc,UnitModel,BedRooms,Country,Nationality,PrefProperties,ActivityLeadType,ActivityStatus',
      );
      const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
      setUnitClass(res?.data?.dropdowns?.UnitClass);
      setProperties(res?.data?.dropdowns?.Properties);
      setUnitView(res?.data?.dropdowns?.UnitView);
      setUnitTypeDesc(res?.data?.dropdowns?.UnitTypeDesc);
      setUnitModel(res?.data?.dropdowns?.UnitModel);
      setBedRooms(res?.data?.dropdowns?.BedRooms);
      setCountries(res?.data?.dropdowns?.Country);
      setNationalitylist(res?.data?.dropdowns?.Nationality);
      setPropertyList(res?.data?.dropdowns?.PrefProperties);
      setActivityLeadType(res?.data?.dropdowns?.ActivityLeadType);
      setActivityStatus(res?.data?.dropdowns?.ActivityStatus);
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handleBackClick = () => {
    window.history.back();
  };
  const handleSave = async () => {
    try {
      setloader(true);
      const currentDatetimeUTC = new Date().toISOString();
      for (const rule of validationRules) {
        if (!transectionData?.[rule.key]) {
          setloader(false);
          toast.warning(rule.message);
          return;
        }
      }
      if (!/^\S+@\S+\.\S+$/.test(transectionData.email)) {
        setloader(false);
        toast.warning('Please Enter Valid Email');
        return;
      }
      let fullName = transectionData?.firstName + ' ' + transectionData?.lastName;
      const validParam = new URLSearchParams();
      validParam.append('Action', 'CheckPrimaryContact');
      validParam.append('TenantNo', '0');
      validParam.append('TenantName', fullName);
      validParam.append('CustomerType', transectionData?.countryCode?.dialCode);
      validParam.append('UnitRefNo', transectionData?.mobileNo);
      const validRes = await apiService.getApiParamater('CUSTOMER_COMMON', `?${validParam.toString()}`);
      const value = Object.values(validRes?.result?.data || {})[0];
      if (value) {
        setloader(false);
        toast.warning('User with this name already exists');
        return;
      }
      const countryCode = transectionData?.countryCode?.dialCode?.toString() || '';

      const phoneWithoutCode = transectionData?.mobileNo?.toString().startsWith(countryCode)
        ? transectionData.mobileNo.toString().slice(countryCode.length)
        : transectionData.mobileNo;

      let customerMaster = {
        record_id: 0,
        customertype: transectionData.type?.label || '',
        customer_no: '0',
        title: transectionData.title?.label,
        customer_Name: fullName || '',
        poBox: transectionData.poBox || '',
        mainaddress1: transectionData.address,
        mainaddress2: '0',
        maincountry: selectedCountry?.label || '',
        maincity: selectedCity?.label || '',
        mainContactno: phoneWithoutCode || '0',
        nationality: transectionData.nationality?.label || '0',
        source: transectionData.source?.label || '0',
        salesPerson: transectionData.salesPerson?.label || '0',
        agent: transectionData.agent?.label || '0',
        remarks: gLAccounts.remarks || '0',
        tradeLicNo: gLAccounts.idNo || '0',
        tL_issue_date: gLAccounts.issueDate || '01-jan-1900',
        tL_Expiry_date: gLAccounts.expiryDate || '01-jan-1900',
        permitted_Use: '0',
        category_Mix: gLAccounts?.categoryMix?.label || '',
        contactPerson: '0',
        contactPersonNo: '0',
        email_id: transectionData.email || '0',
        contactaddress: transectionData?.designation || '0',
        occupation: transectionData?.firstName || '0',
        designation: '0',
        department: transectionData?.lastName || '0',
        cpNationality: transectionData.nationality?.label || '',
        cdate: gLAccounts.dateofBirth || '01-jan-1900',
        status: 'Active',
        exp1: transectionData.firstNameAR || '',
        exp2: transectionData.lastNameAR || '',
        exp3: currentDatetimeUTC,
        modify_by: userName || '',
        modify_on: currentDatetimeUTC,
        createdBy: userName || '',
        createdOn: currentDatetimeUTC,
        accountCode: gLAccounts.accountcode || '0',
        accountName: gLAccounts.accountname || '0',
        sgCode: gLAccounts.sgAccount || '0',
        exp4: transectionData?.leadtype?.label || '0',
        exp5: transectionData?.subsource?.label || '0',
        exp6: '+' + transectionData?.countryCode?.dialCode || '0',
        exp7: '0',
        exp8: transectionData?.companyName || fullName || '0',
        exp9: transectionData?.addressAR || '0',
        exp10: '0',
        exp11: '0',
        exp12: '0',
        exp13: '0',
        exp14: transectionData?.gender?.label || '0',
        exp15: '0',
        exp16: transectionData?.productType?.label || '0',
        exp17: '0',
        vatRegNo: gLAccounts.vatNo || '0',
        taxCode: gLAccounts?.taxCode?.value || 0,
        leadtype: transectionData.leadtype?.label || '0',
      };
      const additionalContatList = contactList?.map((item, index) => {
        return {
          cd_id: 0,
          customer_id: '0',
          contact_type: item?.type?.label || '0',
          country_code: '0',
          area_code: '0',
          contact_no: item?.phone || '0',
          contactPersonBI: item?.contactPerson || '0',
        };
      });
      const activityLists = activityList?.map((item, index) => {
        return {
          recordId: 0,
          activityId: 0,
          leadId: '0',
          customerNo: item?.name || '0',
          customerName: item?.name || '0',
          activityType: item?.type?.label || '0',
          activityPurpose: item?.name || '0',
          activityFromDate: '2025-12-21T05:52:41.499Z',
          activityToDate: '2025-12-21T05:52:41.499Z',
          description: item?.name || '0',
          status: item?.name || '0',
          priority: item?.name || '0',
          assignedTo: item?.name || '0',
          remarks: item?.name || '0',
          exp1: item?.name || '0',
          exp2: item?.name || '0',
          exp3: item?.name || '0',
          exp4: item?.name || '0',
          exp5: item?.name || '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        };
      });
      let uploadedFiles = []
      if (documentsList?.length > 0) {
        uploadedFiles = await handleUpload();
      }
      const customerDocumetsList = documentsList?.map((item) => {
        const uploadedFile = uploadedFiles.find(
          (file) => file.originalFileName === item.file?.name
        );

        return {
          customer_No: "0",
          document_Type: item?.type?.label || "0",
          document_No: item?.documentNo || "0",
          document_Desc: item?.Remarks || "0",
          doc_IssueDate: item?.IssueDate || "0",
          doc_ExpiryDate: item?.expiryDate || "0",

          // Bind uploaded file info
          document_Path: uploadedFile?.filePath || "0",
          // document_Name: uploadedFile?.fileName || "0",
          url: uploadedFile?.fullUrl || "0",
        };
      });
      const preferencesList = preferenceList?.map((item, index) => {
        return {
          recordId: 0,
          leadId: '0',
          customerNo: '0',
          interest: item?.interest?.label || '0',
          community: item?.community || '0',
          location: item?.location?.label || '0',
          property: item?.project?.label || '0',
          unit: item?.unitNo?.label || '0',
          unitType: item?.unitType?.label || '0',
          unitView: item?.view?.label || '0',
          floor: '0',
          bedrooms: item?.bedroom?.label || '0',
          budgetFrom: item?.budgetfrom || '0',
          budgetTo: item?.budgetTo || '0',
          unitArea: item?.unitArea || '0',
          exp1: '0',
          exp2: '0',
          exp3: '0',
          exp4: '0',
          exp5: '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        };
      });
      debugger
      const additionalAddressList = addressList?.map((item, index) => {
        return {
          cD_ID: '0',
          customeR_ID: '0',
          addresS_TYPE_ID: item?.type?.label || '0',
          pobox: item?.poBox || '0',
          linE1: item?.address1 || '0',
          linE2: item?.address2 || '0',
          linE3: '0',
          countrY_CODE: item?.country?.label || '0',
          citY_CODE: item?.city?.label || '0',
        };
      });
      const getSearchCustomerList = [
        {
          recordId: 0,
          customerNo: '0',
          accountCode: '0',
          customerType: transectionData?.type?.label || '0',
          customerName: fullName || '0',
          contactNo: transectionData?.phoneNo || '0',
          emailId: transectionData?.email || '0',
          salesPerson: transectionData?.salesPerson?.label || '0',
          source: transectionData?.source?.label || '0',
          nationality: transectionData?.nationality?.label || '0',
          agent: transectionData?.agent?.label || '0',
          city: selectedCity?.label || '0',
          country: selectedCountry?.label || '0',
          createdBy: userName || '0',
          createdOn: currentDatetimeUTC,
          modifiedBy: userName || '0',
          modifiedOn: currentDatetimeUTC,
        },
      ];
      const tenantDependentList = dependentList?.map((item, index) => {
        return {
          recordId: 0,
          customer_No: '0',
          relationType: item?.type?.label || '0',
          dependentName: item?.name || '0',
          gender: item?.gender?.label || '0',
          age: parseInt(item?.age) || 0,
          dateOfBirth: moment(item?.dateofBirth || '1900-01-01').format() || '1900-01-01T07:16:06.672Z',
          occupation: item?.occupation || '0',
          emailId: item?.email || '0',
          mobileNo: item?.mobileNo || '0',
          passportNo: item?.passport || '0',
          issueDate: '1900-01-01T07:16:06.672Z',
          expiryDate: '1900-01-01T07:16:06.672Z',
          nationality: item?.nationality?.label || '0',
          country: item?.country?.label || '0',
          city: item?.city?.label || '0',
          address: item?.address || '0',
          poBoxNo: item?.poBox || '0',
          createdBy: userName,
        };
      });
      const body = {
        customerMain: {
          customerMaster: customerMaster,
          additionalContatList: additionalContatList,
          activityList: activityLists,
          customerDocumetsList: customerDocumetsList,
          preferencesList: preferencesList,
          additionalAddressList: additionalAddressList,
          getSearchCustomerList: getSearchCustomerList,
          tenantDependentList: tenantDependentList,
          createLedger: gLAccounts?.createledger || false,
          custNo: '0',
          rblExpiredDocs: '0',
        },
      };

      const postRes = await apiService.post('POST_CUSTOMER', body);
      if (postRes?.data?.statusCode === 201) {
        toast.success(postRes?.data?.message);
        setloader(false);
        navigate('/Customer/Property/Master/Customer/Listing');
      } else {
        toast.warning(`${postRes?.data?.message}`);
        setloader(false);
      }
    } catch (error) {
      console.error('Error Save Data', error);
      setloader(false);
    } finally {
      setloader(false);
    }
  };
  const handleCountryChange = async (selectedOption) => {
    const params = new URLSearchParams();
    params.append('DropdownFor', 'CustCityDescByCountry');
    params.append('CascadText', selectedOption?.label);
    const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
    setCityList(res?.data?.items);
    setSelectedCountry(selectedOption);
    setSelectedCity(null);
    // fetchCities(selectedOption)
  };
  const handleUpload = async (ref_No) => {
    const formData = new FormData();
    let token = localStorage.getItem('Token');
    let db = localStorage.getItem('DataBase');
    // const validFiles = attachments.filter(
    //     (item) => item.file instanceof File
    // );
    const validFiles = documentsList?.filter((item) => item.file instanceof File);
    validFiles.forEach(({ file }) => {
      
      formData.append('files', file);
    });
    formData.append('refNo', "CustomerFiles");
    formData.append('fileCategory', 'Images');

    const response = await axios.post(endPoint.UNIT_FILE, formData, {
      headers: {
        accept: 'text/plain',
        apikey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
        Authorization: `Bearer ${token}`,
        db: db,   
      },
    });
    
    if (response?.data) {
      return response?.data?.result || [];
      // additionalDataUpload(response?.data?.result, ref_No);
    }
  };
  return (
    <div className="p-3">
      {/* Filters */}

      <div className="border-box2 p-2 d-flex justify-content-between" style={{ borderRadius: '8px' }}>
        <div className="">
          <h6>Tenant Management</h6>
        </div>
        <div className="d-flex gap-3">
          {loading === true ? (
            <div className="mainbtn flex-end gap-2">
              <ClipLoader color="#ffffff" className="mt-1" size={25} />
            </div>
          ) : (
            <div className="mainbtn flex-end gap-2" onClick={handleSave}>
              <FaSave color="#fff" className="center mt-1 mx-2" />
              <div className="center">Save</div>
            </div>
          )}
          <div className="mainbtnSecondary flex-end gap-2" onClick={handleBackClick}>
            <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
            <div className="center">Back</div>
          </div>
        </div>
      </div>
      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Personal Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 4 ? 'sideActive' : ''}`} onClick={() => handleTabClick(4)}>
            Other Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Additional Contact
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 7 ? 'sideActive' : ''}`} onClick={() => handleTabClick(7)}>
            Additional Address
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 8 ? 'sideActive' : ''}`} onClick={() => handleTabClick(8)}>
            Dependent Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Documents Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 5 ? 'sideActive' : ''}`} onClick={() => handleTabClick(5)}>
            Preference
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Activity
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 6 ? 'sideActive' : ''}`} onClick={() => handleTabClick(6)}>
            Deal
          </div>
        </div>
      </div>
      {/* Lease Details */}
      {gridVisibility[0] && (
        <PersonalDetails
          tableLoading={tableLoading}
          nationalityList={nationalityList}
          countriesList={countriesList}
          cityList={cityList}
          handleCountryChange={handleCountryChange}
          sourceList={sourceList}
          customerTypeList={customerTypeList}
          salesPersonList={salesPersonList}
          selectedCity={selectedCity}
          setTransectionData={setTransectionData}
          leadStatus={leadStatus}
          selectedCountry={selectedCountry}
          setSelectedCountry={setSelectedCountry}
          setSelectedCity={setSelectedCity}
          transectionData={transectionData}
          agentList={agentList}
          titleList={titleList}
          leadType={personalTabLeadType}
          categoryMix={categoryMix}
          defaultCountry={defaultCountry}
          packageName={packageName}
        />
      )}
      {gridVisibility[1] && (
        <ContactDetails
          setContactList={setContactList}
          addContactType={addContactType}
          contactList={contactList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
      {gridVisibility[7] && (
        <AddressDetails
          setAddressList={setAddressList}
          addAddressType={addAddressType}
          addressList={addressList}
          countriesList={countriesList}
          cityList={cityList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
      {gridVisibility[2] && <DocumentDetails documentType={documentType} setDocumentsList={setDocumentsList} documentsList={documentsList} />}
      {gridVisibility[3] && (
        <Activity
          activityRating={activityRating}
          language={language}
          woContact={woContact}
          activityStatus={activityStatus}
          setActivityList={setActivityList}
          activityList={activityList}
          ativityLeadType={ativityLeadType}
        />
      )}

      {gridVisibility[4] && (
        <GLAccount
          categoryMix={categoryMix}
          transectionData={transectionData}
          countriesList={countriesList}
          setGLAccounts={setGLAccounts}
          gLAccounts={gLAccounts}
          taxList={taxList}
          acountCodes={acountCodes}
        />
      )}
      {gridVisibility[5] && (
        <PreferenceDetails
          setPreferenceList={setPreferenceList}
          prefIntrest={prefIntrest}
          prefBuying={prefBuying}
          Properties={Properties}
          UnitTypeDesc={UnitTypeDesc}
          preferenceList={preferenceList}
          locationMaster={locationMaster}
          UnitClass={UnitClass}
          UnitView={UnitView}
          UnitModel={UnitModel}
          packageName={propertylist}
          bedRooms={bedRooms}
        />
      )}
      {gridVisibility[8] && (
        <DependentDetails
          setDependentList={setDependentList}
          addAddressType={addAddressType}
          dependentList={dependentList}
          countriesList={countriesList}
          cityList={cityList}
          currencyPrecision={currencyPrecision}
          defaultCountry={defaultCountry}
        />
      )}
    </div>
  );
};
export default CustomerMaster;
